<script>
	import TBox from './templates/TBox.svelte';
</script>

<TBox 
	titulo="Não Encontrado" 
	largura="6" 
	deslocamento="3" 
	correcaoY="-13px"
	icone="emoji_assustado">

	<div class="has-text-centered">
		<p class="is-size-1">A página ou recurso solicitado não existe.</p>
	</div>

	<hr>

	<br>

	<div class="has-text-centered">
		<div class="columns">
			<div class="column">
				<a href="#/" class="button is-black is-outlined is-medium is-fullwidth pb">Início</a>
			</div>
			<div class="column">
				<a href="#/login" class="button is-primary is-medium is-fullwidth pb">Login</a>
			</div>
		</div>
	</div>
</TBox>